import Box, { Flex } from '@spotnana/pixel-react/dist/Box';
import Typography from '@spotnana/pixel-react/dist/Typography';
import { ColorVariantEnum } from 'obt-common/types/Flights/fareChangeBreakupNode';
import styled from 'styled-components';

export const FareBreakupContainer = styled(Box)``;

export const HeaderText = styled(Typography)`
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
`;

export const Row = styled(Flex)`
  align-items: center;
  justify-content: space-between;
  margin: 8px 0px;
`;

export const NormalText = styled(Typography)<{ colorVariant: boolean; strikethroughValue?: boolean }>`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${({ colorVariant, theme }) => {
    if (colorVariant === ColorVariantEnum.SUCCESS) {
      return theme.colors.text.darkSeaGreen;
    }

    if (colorVariant === ColorVariantEnum.DANGER) {
      return theme.colors.text.newErrorRed;
    }
    return theme.colors.text.newGray50;
  }};

  text-decoration: ${({ strikethroughValue }) => {
    if (strikethroughValue) {
      return 'line-through';
    }
    return undefined;
  }};
`;

export const DangerValue = styled(Typography)`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.text.newErrorRed};
  margin-right: 16px;
`;

export const SubText = styled(Typography)`
  color: ${({ theme }) => theme.colors.text.newGray50};
  font-size: 12px;
  margin-top: 4px;
  line-height: 16px;
`;

export const BannerContainer = styled(Flex)`
  align-items: center;
  height: 48px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.border.lightYellow};
  background: ${({ theme }) => theme.colors.bg.lightYellow2};
  border-left: 5px solid ${({ theme }) => theme.colors.bg.lightYellowInfo};
  padding: 12px 16px;
  margin-bottom: 24px;
`;

export const BannerText = styled(Typography)`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  margin-left: 16px;
`;

export const BreakupDivider = styled(Box)`
  border: 1px solid ${({ theme }) => theme.colors.border.grey10};
  height: 0px;
  margin: 16px 0px;
`;
